(function () {
  var STORAGE_KEY = 'cpbPreferredCartLocalePrefix';
  var EXPIRES_KEY = 'cpbPreferredCartLocaleExpiresAt';
  var TTL_MS = 10 * 60 * 1000; // 10 minutes

  function getLocalePrefix() {
    var match = window.location.pathname.match(/^\/(fr)(?=\/|$)/);
    return match ? '/' + match[1] : '';
  }

  function isBareCartPage() {
    return window.location.pathname === '/cart';
  }

  function isLocalizedCartPage() {
    return /^\/fr\/cart\/?$/.test(window.location.pathname);
  }

  function isProbablyCpbProductPage() {
    if (!/\/products\//.test(window.location.pathname)) return false;

    return Boolean(
      document.querySelector('#product-builder') ||
      document.querySelector('.cpb-product-actions') ||
      document.querySelector('.cpb-panels-container') ||
      document.querySelector('[class*="cpb-"]') ||
      document.querySelector('script[src*="thecustomproductbuilder"]') ||
      document.querySelector('iframe[src*="thecustomproductbuilder"]')
    );
  }

  function saveLocaleForCpbCart() {
    var prefix = getLocalePrefix();

    if (prefix !== '/fr') return;

    try {
      localStorage.setItem(STORAGE_KEY, prefix);
      localStorage.setItem(EXPIRES_KEY, String(Date.now() + TTL_MS));
    } catch (error) {}
  }

  function clearSavedLocale() {
    try {
      localStorage.removeItem(STORAGE_KEY);
      localStorage.removeItem(EXPIRES_KEY);
    } catch (error) {}
  }

  function getSavedLocale() {
    try {
      var prefix = localStorage.getItem(STORAGE_KEY);
      var expiresAt = Number(localStorage.getItem(EXPIRES_KEY) || 0);

      if (!prefix || !expiresAt || Date.now() > expiresAt) {
        clearSavedLocale();
        return '';
      }

      return prefix;
    } catch (error) {
      return '';
    }
  }

  function redirectBareCartToLocalizedCart() {
    if (!isBareCartPage()) return;

    var prefix = getSavedLocale();

    if (prefix === '/fr') {
      clearSavedLocale();
      window.location.replace(prefix + '/cart' + window.location.search + window.location.hash);
    }
  }

  function bindCpbAddToCartTracking() {
    if (!isProbablyCpbProductPage()) return;

    saveLocaleForCpbCart();

    document.addEventListener(
      'click',
      function (event) {
        var target = event.target;
        if (!target) return;

        var addButton = target.closest(
          [
            'button[name="add"]',
            'button[type="submit"]',
            '[data-add-to-cart]',
            '.shopify-payment-button__button',
            '.cpb-product-actions button',
            '#product-builder button',
            'button'
          ].join(',')
        );

        if (!addButton) return;

        var text = (addButton.textContent || '').trim().toLowerCase();

        if (
          text.includes('add to cart') ||
          text.includes('ajouter au panier') ||
          text.includes('add') ||
          addButton.closest('.cpb-product-actions') ||
          addButton.closest('#product-builder')
        ) {
          saveLocaleForCpbCart();
        }
      },
      true
    );

    document.addEventListener(
      'submit',
      function (event) {
        var form = event.target;
        if (!form || !form.matches || !form.matches('form')) return;

        if (
          form.closest('#product-builder') ||
          form.closest('.cpb-product-actions') ||
          form.action.indexOf('/cart/add') !== -1
        ) {
          saveLocaleForCpbCart();
        }
      },
      true
    );
  }

  redirectBareCartToLocalizedCart();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindCpbAddToCartTracking);
  } else {
    bindCpbAddToCartTracking();
  }

  if (isLocalizedCartPage()) {
    clearSavedLocale();
  }
})();